import { names } from '@prolaera/library';
import { licenses } from '@prolaera/library';

export default function() {
  return (input, type) => {
    let nameDict = names;

    if (!input) return '';

    input = input.toLowerCase();

    if (type === 'license') nameDict = { ...nameDict, ...licenses };

    if (nameDict[input]) return nameDict[input];

    if (input.indexOf('_') > -1) {
      return input
        .split(/_/)
        .map(word => {
          if (word.length <= 2) return word.toUpperCase();
          return word.substring(0, 1).toUpperCase() + word.substring(1);
        })
        .join(' ');
    }

    if (input.indexOf(' ') > -1) {
      return input
        .split(' ')
        .map(word => {
          if (word.toLowerCase() === 'cpa') return 'CPA';
          if (word.length <= 2) return word.toUpperCase();
          return word.substring(0, 1).toUpperCase() + word.substring(1);
        })
        .join(' ');
    }

    return input.substring(0, 1).toUpperCase() + input.substring(1);
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/Capitalize.js